import { useState } from "react";
import { Menu, Phone, X } from "lucide-react";
import { contact, whatsappUrl } from "@/data/brand";
import { track } from "@/services/metrics";

const nav = [
  ["Home", "/"],
  ["Production", "/production"],
  ["R&D", "/rnd"],
  ["Gear", "/store"],
  ["Events", "/events"],
];

export const SiteHeader = ({ onQuote }) => {
  const [open, setOpen] = useState(false);
  const currentPath = window.location.pathname;
  return (
    <header className="site-header" data-testid="site-header">
      <a href="/" className="brand-mark" data-testid="header-logo-link">
        <img src="/media/brand/madminute-mark-black.png" alt="MADMINUTE official logo" className="official-brand-logo header-brand-logo" data-testid="header-official-logo" />
        <span>MADMINUTE</span>
      </a>
      <nav className={open ? "nav-links is-open" : "nav-links"} data-testid="primary-navigation">
        {nav.map(([label, path]) => (
          <a key={path} href={path} className={currentPath === path ? "active" : undefined} data-testid={`nav-${label.toLowerCase().replace("&", "and")}-link`}>
            {label}
          </a>
        ))}
        <a href={whatsappUrl("Hi MADMINUTE, I would like to discuss a project.")} target="_blank" rel="noreferrer" onClick={() => track("whatsapp_click")} data-testid="header-whatsapp-link">
          WhatsApp
        </a>
        <button className="button button-primary nav-quote" onClick={() => { onQuote("General"); setOpen(false); }} data-testid="header-request-quote-button">
          Request quote
        </button>
      </nav>
      <a className="header-phone" href={`tel:${contact.phoneHref}`} data-testid="header-phone-link" aria-label="Call MADMINUTE">
        <Phone size={18} />
      </a>
      <button className="menu-button" onClick={() => setOpen(!open)} data-testid="mobile-menu-button" aria-label="Toggle menu">
        {open ? <X /> : <Menu />}
      </button>
    </header>
  );
};
